module.exports = __webpack_public_path__ + "img/yangyi_p.443a36df.png";